import type { BotDifficulty, BotPersonalitySelection } from "../bot-types.js";
import { type MapId, topology } from "../content/setup.js";
import type { ConflictConfig, DurationPresetId } from "../types.js";

export interface PracticeLobbySettings {
  readonly townName: string;
  readonly aiCount: number;
  readonly mapId: MapId;
  readonly durationPreset: DurationPresetId;
  readonly clockSpeed: 1 | 2;
  readonly botPersonality: BotPersonalitySelection;
  readonly botDifficulty: BotDifficulty;
}

export function practiceConfig(settings: PracticeLobbySettings, townName: string): ConflictConfig {
  const ids = Array.from({ length: settings.aiCount + 1 }, (_, index) =>
    index === 0 ? "player" : `ai-${index}`,
  );
  const edges = topology(settings.mapId, ids);
  return {
    matchId: "browser-practice",
    rootSeed: "6b696c6e66726f6e742d62726f777365722d7072616374696365",
    mode: "private-practice",
    mapId: settings.mapId,
    durationPreset: settings.durationPreset,
    seats: ids.map((id, index) => ({
      id,
      name: index === 0 ? townName : `Clockwork ${index}`,
      adjacentTo: edges.flatMap(([left, right]) =>
        left === id ? [right] : right === id ? [left] : [],
      ),
      ...(index > 0
        ? {
            bot: {
              personality: settings.botPersonality,
              difficulty: settings.botDifficulty,
            },
          }
        : {}),
    })),
  };
}
